import { SimpleCatalog } from './simple-catalog.js';
import { TypedCatalog } from './typed-catalog.js';
/**
 * Catalog of all available components and their metadata.
 */
class Catalog {
    /**
     * Register a component in the catalog.
     *
     * @param name - Component name;
     * @param metadata - Component information;
     */
    static register(name, metadata) {
        // metadata.validate();
        const type = metadata.getType();
        this.catalog
            .get(type)
            .set(name, metadata);
        this.cache.set(name, metadata);
    }
    /**
     * Obtains the information from a given component.
     *
     * @param name - Component name.
     */
    static get(name) {
        return this.cache.get(name);
    }
    /**
     * Checks if there's a component with a given name.
     *
     * @param name - Component name.
     */
    static has(name) {
        return this.cache.has(name);
    }
    /**
     * Retrieve the names of all components with a given type.
     *
     * @param type - Component type.
     */
    static listByType(type) {
        if (!this.catalog.has(type)) {
            return [];
        }
        return Array.from(this.catalog.get(type).keys());
    }
}
Catalog.catalog = new TypedCatalog();
Catalog.cache = new SimpleCatalog('');
export { Catalog, };
//# sourceMappingURL=catalog.js.map